import { apiCall } from "./authServieces";

export const FetchUserProfileData = async() => {
    try{
        const response = await apiCall({
            endpoint: "api/profile/get-user-profile-data",
            method: "GET",     
        });
        return response;
    }catch(error){
        throw error;
    }
}